import { Localizations } from '@/app/Utilities/localization/index';
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root',
})
export class LocalizationViewModel {
     localization = Localizations
}